import { Injectable, Injector } from "@angular/core";
@Injectable({
  providedIn: "root"
})
export class ErrorPageService {
  constructor() {}
  error: Error = {
    message:"Ooops! Qualcosa è andato storto! Ricarica la pagina per favore",
    name:""
  }
  setError(error: any) {
    this.error = {
      ...error,
      url:"/"
    }
  }
  getError() {
    return this.error;
  }
}
